// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + "d0deef33" + "." + "5ad5133a2608f5cf" + ".js";
};